export default __webpack_public_path__ + "static/media/screen1.d66c5e06.png";